export default __webpack_public_path__ + "static/content-fd3132c120c15237a1dcf24e38f59f2a.jpg";